import { render, staticRenderFns } from "./affiliate_dependent.vue?vue&type=template&id=397ac235"
import script from "./affiliate_dependent.vue?vue&type=script&lang=js"
export * from "./affiliate_dependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports